export const replaceCodeToHtml = (s?: string): string => {
  if (!s) return ""
  const RegexOpen = /\[(?<className>\w+)\]/ug
  const RegexClose = /\[\/\w+\]/ug
  return s.replace(RegexOpen, "<span class='$<className>'>").replace(RegexClose, "</span>")
}
